import { AdminNavbar } from '../navbar/AdminNavbar';

export const App = (props: any) => {
	return <AdminNavbar {...props} />;
};
